import { render, staticRenderFns } from "./IconArrowRight.vue?vue&type=template&id=964ca4c2&scoped=true&lang=pug&"
import script from "./IconArrowRight.vue?vue&type=script&lang=js&"
export * from "./IconArrowRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964ca4c2",
  null
  
)

export default component.exports